import type { ReactNode } from "react";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  onBack?: () => void;
}

export function PageHeader({
  title,
  description,
  actions,
  onBack,
}: PageHeaderProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between md:gap-4">
      <div className="space-y-0.5 md:space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">
          {title}
        </h1>
        {description ? (
          <div className="text-sm text-muted-foreground">{description}</div>
        ) : null}
      </div>
      {onBack || actions ? (
        <div className="flex shrink-0 items-center gap-2">
          {onBack && (
            <Button variant="outline" onClick={onBack}>
              <ArrowLeft className="mr-2 h-4 w-4" />
              {t("pages.common.back")}
            </Button>
          )}
          {actions}
        </div>
      ) : null}
    </div>
  );
}
